<template>
  <div class="k-card">

    <div
      class="background"
      :style="{background: card.background}"
    >
      <k-icon
        icon="favorite-filled"
        class="favorite"
        v-if="card.favorited"
      />
      <img
        :src="card.img"
        :alt="card.title"
      />
    </div>
    <div class="content">
      <div class="content-text">
        <h3 class="title">{{ card.title }}</h3>
        <p class="subtitle">
          {{ subtitle }}
        </p>
        <k-tag
          v-if="tag"
          :color="tagContent.color"
          class="card-tag"
        >
          {{ tagContent.text }}
        </k-tag>
      </div>
      <like
        :liked="card.liked"
        @click="handleLike"
        :likes="card.likes"
      />
    </div>
  </div>
</template>

<script>
import Like from './Like.vue';
export default {
  name: 'KCard',
  props: {
    card: {
      type: Object,
      default: () => { }
    },
    tag: {
      type: Boolean,
      default: false
    },
    tagContent: {
      type: Object,
      default: () => { }
    }
  },
  components: {
    KTag: () => import('./KTag.vue'),
    KIcon: () => import('./KIcon.vue'),
    Like,
  },
  computed: {
    subtitle () {
      let text = this.card.subtitle
      if (this.card.distance) {
        const distance = `${this.card.distance}`.replace('.', ',')
        text += ` • ${distance} km`
      }
      return text
    }
  },
  methods: {
    handleLike () {
      if (this.card.liked) this.$emit('unlike')
      else this.$emit('like')
    }
  }
};
</script>

<style lang='scss'>
@import "../assets/scss/main.scss";

.k-card {
  max-width: 200px;
  .background {
    width: 200px;
    height: 140px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all ease 0.3s;
    position: relative;
    img {
      max-width: 120px;
    }
    .favorite {
      position: absolute;
      right: -10px;
      top: -10px;
      color: #ffd103;
      -webkit-text-stroke: 2px white;
      font-size: 24px;
    }
    &:hover {
      background: lighten($neutral-1, 60%) !important;
    }
  }
  .content {
    display: flex;
    align-items: flex-start;
    padding-top: $spacing-xs;
    justify-content: space-between;
    .content-text {
      width: 60%;
      .title {
        margin: 0px;
        text-align: left;
        padding-bottom: $spacing-xxs;
        @include heading-5;
      }
      .subtitle {
        color: lighten($neutral-1, 40%);
        text-align: left;
        @include body-5;
        margin: 0px;
        padding-bottom: $spacing-xs;
      }
      .card-tag {
        font-size: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/kaledo-components/src/components/KCard.vue